import { render, staticRenderFns } from "./ListNotificacionPage.vue?vue&type=template&id=2b90943b"
import script from "./ListNotificacionPage.vue?vue&type=script&lang=js"
export * from "./ListNotificacionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports